(() => {
  const headerRoot =
    document.querySelector('.shopify-section.header') ||
    document.querySelector('.header');
  if (!headerRoot) return;

  const logo = headerRoot.querySelector('.logo');
  const logoWhite = headerRoot.querySelector('.logo-white');
  const luminanceCache = new Map();
  let contrastFrame = 0;

  // Clear legacy inline logo toggles so CSS classes own contrast.
  const clearLegacyLogoStyles = () => {
    if (logo) logo.style.removeProperty('display');
    if (logoWhite) logoWhite.style.removeProperty('display');
  };

  const getImageLuminance = (img) => {
    const src = img.currentSrc || img.src;
    if (!src) return Promise.resolve(null);
    if (luminanceCache.has(src)) return Promise.resolve(luminanceCache.get(src));

    return new Promise((resolve) => {
      const probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          const sampleW = 48;
          const sampleH = 12;
          canvas.width = sampleW;
          canvas.height = sampleH;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          const srcH = Math.max(1, Math.round(probe.naturalHeight * 0.12));
          ctx.drawImage(probe, 0, 0, probe.naturalWidth, srcH, 0, 0, sampleW, sampleH);
          const data = ctx.getImageData(0, 0, sampleW, sampleH).data;
          let total = 0;
          const pixels = data.length / 4;
          for (let i = 0; i < data.length; i += 4) {
            total += (0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]) / 255;
          }
          const avg = total / pixels;
          luminanceCache.set(src, avg);
          resolve(avg);
        } catch (e) {
          resolve(null);
        }
      };
      probe.onerror = () => resolve(null);
      probe.src = src;
    });
  };

  const findBackdropImage = () => {
    const rect = headerRoot.getBoundingClientRect();
    const y = Math.min(Math.max(rect.bottom - 2, 0), window.innerHeight - 1);
    const xs = [0.12, 0.5, 0.88].map((p) => rect.left + rect.width * p);

    for (const x of xs) {
      const stack = document.elementsFromPoint(x, y);
      for (const el of stack) {
        if (headerRoot.contains(el)) continue;
        if (el.tagName === 'IMG' && (el.currentSrc || el.src)) return el;
        if (el.tagName === 'VIDEO' && el.poster) {
          const poster = new Image();
          poster.src = el.poster;
          return poster;
        }
        const bg = getComputedStyle(el).backgroundImage;
        const match = bg && bg !== 'none' ? bg.match(/url\(["']?(.*?)["']?\)/) : null;
        if (match && match[1]) {
          const bgImg = new Image();
          bgImg.src = match[1];
          return bgImg;
        }
      }
    }

    const heroes = document.querySelectorAll('.hero-image, .hero-section img');
    for (const hero of heroes) {
      const heroRect = hero.getBoundingClientRect();
      if (heroRect.bottom > rect.top + 8 && heroRect.top < rect.bottom) return hero;
    }
    return null;
  };

  const applyHeaderContrast = async () => {
    clearLegacyLogoStyles();

    const overlayOpen = Boolean(
      document.querySelector('.burger-menu-overlay.active') ||
        document.querySelector('.burger-menu-overlay-nested.active') ||
        document.querySelector('.search-overlay.active')
    );

    if (overlayOpen) {
      headerRoot.classList.remove('header--on-dark');
      return;
    }

    const backdrop = findBackdropImage();
    if (!backdrop) {
      headerRoot.classList.remove('header--on-dark');
      return;
    }

    const luminance = await getImageLuminance(backdrop);
    const onDark =
      luminance !== null ? luminance < 0.58 : window.location.pathname === '/';
    headerRoot.classList.toggle('header--on-dark', onDark);
    clearLegacyLogoStyles();
  };

  const scheduleHeaderContrast = () => {
    if (contrastFrame) cancelAnimationFrame(contrastFrame);
    contrastFrame = requestAnimationFrame(() => {
      contrastFrame = 0;
      applyHeaderContrast();
    });
  };

  window.addEventListener('scroll', scheduleHeaderContrast, { passive: true });
  window.addEventListener('resize', scheduleHeaderContrast);
  document.addEventListener('shopify:section:load', scheduleHeaderContrast);

  // Run after legacy header IIFE (compiled_assets) may have toggled logos.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(applyHeaderContrast, 0);
    });
  } else {
    setTimeout(applyHeaderContrast, 0);
  }

  document.querySelectorAll('.hero-image').forEach((img) => {
    if (img.complete) return;
    img.addEventListener('load', scheduleHeaderContrast, { once: true });
  });
})();
